import { h } from "preact";

export default function FollowDesinger({ name, collectionHandle, className }) {
  return (
    <follow-designer
      className={className}
      designer-collection-handle={collectionHandle}
      designer-name={name}
      element-layout="flag"
    ></follow-designer>
  );
}
